import { render } from "./LeaderboardGraph.vue?vue&type=template&id=0dd08785&scoped=true"
import script from "./LeaderboardGraph.vue?vue&type=script&lang=js"
export * from "./LeaderboardGraph.vue?vue&type=script&lang=js"

import "./LeaderboardGraph.vue?vue&type=style&index=0&id=0dd08785&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd08785"]])

export default __exports__